module.exports = __webpack_public_path__ + "static/media/vector-preview.06d496fb.svg";